var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutrition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C4.55228 0 5 0.447715 5 1V5H6V1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1V5H9V1C9 0.447715 9.44772 0 10 0C10.5523 0 11 0.447715 11 1V7C11 8.86687 9.72695 10.4314 8 10.8744V13.1718C9.16322 13.5852 10 14.6981 10 16V21C10 22.6523 8.65228 24 7 24C5.34772 24 4 22.6523 4 21V16C4 14.6981 4.83678 13.5852 6 13.1718V10.8744C4.27305 10.4314 3 8.86687 3 7V1C3 0.447715 3.44772 0 4 0ZM9 7H5C5 8.10772 5.89228 9 7 9C8.10772 9 9 8.10772 9 7ZM19 2.17049C17.8344 2.58204 17 3.69298 17 5V13H19V2.17049ZM19 15H18.7543L17.0068 21.1161C17.0653 21.6102 17.4915 22 18 22C18.5477 22 19 21.5477 19 21V15ZM16.6743 15L15.0385 20.7253C15.0129 20.8146 15 20.9071 15 21C15 22.6523 16.3477 24 18 24C19.6523 24 21 22.6523 21 21V1C21 0.447715 20.5523 0 20 0C17.2377 0 15 2.23772 15 5V14C15 14.5523 15.4477 15 16 15H16.6743ZM7 15C6.45228 15 6 15.4523 6 16V21C6 21.5477 6.45228 22 7 22C7.54772 22 8 21.5477 8 21V16C8 15.4523 7.54772 15 7 15Z",
    style: {
      fill: "var(--color, currentColor)",
      stroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.4b4a6ed2.svg";
export { ForwardRef as ReactComponent };